module.exports = __webpack_public_path__ + "media/images/icons/parcel-854915692249b506fd514c80b4a3b694.svg";